export const descriptions = {
  signAgreement:
    "By entering my password, I acknowledge that the information recorded was entered by me and I am authorized by the organization to record and sign the evaluation."
};
